import React from 'react';
import Spacer from '../shared/Spacer';
import ChartsPlate from './charts/ChartsPlate';
import StudentsPlate from 'features/monitoring/students/StudentsPlate';
import CorrectPercentPlate from 'features/monitoring/percents/CorrectPercentPlate';
import { Container, Header } from 'features/shared/ui/Page';

import LoaderComponent from 'features/shared/Loader';

import useFetchMonitoringData from './hooks/useFetchMonitoringData';
import useUserData from 'hooks/useUserData';
import { useBannersContext } from 'features/shared/Banners/BannersContext';
import Banners from 'features/shared/Banners/Banners';
import GeneralStatistics from './GeneralStatistics';

const Component = () => {
  const { banners } = useBannersContext({ section: 'knowledge_slices' });
  const { tests, participants } = useFetchMonitoringData();
  const { isRegion: isRegionValue, isLargeCity } = useUserData() || {};
  const isRegion = isRegionValue || isLargeCity || false;

  return (
    <Container>
      <Header>Срезы знаний</Header>
      <Spacer size={24} />
      {!tests ? (
        <LoaderComponent />
      ) : (
        <>
          <GeneralStatistics isRegion={isRegion} />
          <Spacer size={48} />
          {banners.length ? (
            <>
              <Banners section="knowledge_slices" />
              <Spacer size={48} />
            </>
          ) : null}
          <ChartsPlate tests={tests} participants={participants} />
          <Spacer size={48} />
          <StudentsPlate tests={tests} participants={participants} isRegion={isRegion} />
          <Spacer size={48} />
          <CorrectPercentPlate tests={tests} isRegion={isRegion} />
        </>
      )}
    </Container>
  );
};

export default Component;
